"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheFirst = void 0;
var check_if_old_cache_1 = require("../_utils/check-if-old-cache");
var open_cache_1 = require("../_utils/open-cache");
var write_to_cache_1 = require("../_utils/write-to-cache");
var CacheFirst = /** @class */ (function () {
    function CacheFirst(_a) {
        var _this = this;
        var timestamp = _a.timestamp, storageCacheName = _a.storageCacheName, requestCacheKey = _a.requestCacheKey, debugCacheLogger = _a.debugCacheLogger;
        this.cacheRequest = function (_a) {
            var request = _a.request, onUpdateCache = _a.onUpdateCache, _b = _a.expires, expires = _b === void 0 ? 0 : _b, disabledCache = _a.disabledCache, expiresToDate = _a.expiresToDate, onRequestError = _a.onRequestError, onCacheHit = _a.onCacheHit, onCacheMiss = _a.onCacheMiss, quotaExceed = _a.quotaExceed, cacheState = _a.cacheState;
            return __awaiter(_this, void 0, void 0, function () {
                var cache, response, cacheMatch, _c, old, cachedResponse, _d, size, networkResponse;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            this.debugCacheLogger.openLogsGroup({
                                requestCacheKey: this.requestCacheKey,
                            });
                            this.debugCacheLogger.logParams({
                                params: JSON.stringify({
                                    strategy: 'CacheFirst',
                                    expiresToDate: expiresToDate,
                                    disabledCache: disabledCache,
                                    'api-expires': this.timestamp + expires,
                                    timestamp: this.timestamp,
                                    storageCacheName: this.storageCacheName,
                                    requestCacheKey: this.requestCacheKey,
                                }),
                            });
                            return [4 /*yield*/, (0, open_cache_1.openCache)(this.storageCacheName)];
                        case 1:
                            cache = _e.sent();
                            if (!(disabledCache || !window.caches || !cache)) return [3 /*break*/, 3];
                            return [4 /*yield*/, request()];
                        case 2:
                            response = _e.sent();
                            this.debugCacheLogger.logDisabledCache();
                            this.debugCacheLogger.closeLogsGroup();
                            return [2 /*return*/, response];
                        case 3: return [4 /*yield*/, cache.match("/" + this.requestCacheKey)];
                        case 4:
                            cacheMatch = _e.sent();
                            this.debugCacheLogger.logCacheIsMatched({
                                cacheMatched: Boolean(cacheMatch),
                            });
                            return [4 /*yield*/, (0, check_if_old_cache_1.checkIfOldCache)({
                                    timestamp: this.timestamp,
                                    cacheMatch: cacheMatch,
                                })];
                        case 5:
                            _c = _e.sent(), old = _c.old, cachedResponse = _c.cachedResponse, _d = _c.size, size = _d === void 0 ? 0 : _d;
                            if (old && cacheMatch) {
                                this.debugCacheLogger.logCacheIsExpired();
                            }
                            if (cachedResponse) {
                                this.debugCacheLogger.closeLogsGroup();
                                onCacheHit === null || onCacheHit === void 0 ? void 0 : onCacheHit({
                                    size: size,
                                    expires: expires,
                                    cacheKey: this.requestCacheKey,
                                    cacheState: cacheState,
                                });
                                return [2 /*return*/, cachedResponse];
                            }
                            onCacheMiss === null || onCacheMiss === void 0 ? void 0 : onCacheMiss({ cacheKey: this.requestCacheKey, cacheState: cacheState });
                            return [4 /*yield*/, request()];
                        case 6:
                            networkResponse = _e.sent();
                            if (!!networkResponse.error) return [3 /*break*/, 8];
                            return [4 /*yield*/, (0, write_to_cache_1.writeToCache)({
                                    cache: cache,
                                    requestCacheKey: this.requestCacheKey,
                                    response: networkResponse,
                                    apiExpires: expiresToDate
                                        ? "" + expiresToDate
                                        : "" + (this.timestamp + expires),
                                    apiTimestamp: "" + this.timestamp,
                                    cachedResponse: cachedResponse,
                                    old: old,
                                    onUpdateCache: onUpdateCache,
                                    debugCacheLogger: this.debugCacheLogger,
                                    strategy: 'CacheFirst',
                                    quotaExceed: quotaExceed,
                                })];
                        case 7:
                            _e.sent();
                            return [3 /*break*/, 9];
                        case 8:
                            onRequestError === null || onRequestError === void 0 ? void 0 : onRequestError();
                            this.debugCacheLogger.logNotUpdatedCache({
                                response: JSON.stringify(networkResponse),
                            });
                            _e.label = 9;
                        case 9:
                            this.debugCacheLogger.closeLogsGroup();
                            return [2 /*return*/, networkResponse];
                    }
                });
            });
        };
        this.timestamp = timestamp;
        this.storageCacheName = storageCacheName;
        this.requestCacheKey = requestCacheKey;
        this.debugCacheLogger = debugCacheLogger;
    }
    return CacheFirst;
}());
exports.CacheFirst = CacheFirst;
